/** @format */

import React, { useCallback } from 'react';
import Share from 'components/V2/Share';
import { useModal } from 'modules/ui';

const ShareModal = () => {
	const { shareModal, boundToggleShareModal } = useModal();

	const closeModal = useCallback(() => {
		boundToggleShareModal(false);
	}, [boundToggleShareModal]);

	if (shareModal.isOpen) {
		return <Share closeModal={closeModal} copyContent={shareModal.copy} />;
	} else {
		return null;
	}
};

export default React.memo(ShareModal);
